const navCols = [
  {
    title: "栏目导航",
    links: [
      { label: "首页聚焦", href: "#focus" },
      { label: "实时热榜", href: "#trend" },
      { label: "后续追踪", href: "#news" },
      { label: "时间线复盘", href: "#timeline" },
      { label: "反转盘点", href: "#reversal" },
    ],
  },
  {
    title: "话题专区",
    links: [
      { label: "带货翻车", href: "#topic" },
      { label: "抄袭争议", href: "#topic" },
      { label: "明星解约", href: "#topic" },
      { label: "塌房现场", href: "#topic" },
      { label: "素人爆火", href: "#topic" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-[#33211a] text-[#efe6d8]">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-red-700 text-white">
                <i className="ri-fire-fill text-xl"></i>
              </div>
              <div>
                <p className="font-masthead text-xl font-black">
                  全网<span className="text-red-500">热瓜</span>
                </p>
                <p className="text-[11px] tracking-[0.24em] text-[#efe6d8]/50">
                  后续与最新进展 · 反转 · 当事人回应
                </p>
              </div>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-[#efe6d8]/70">
              专注全网热门事件追踪的信息聚合平台，按话题持续汇总每起事件的时间线、反转节点与当事人最新回应，帮助你从发酵到出结果，掌握完整脉络。
            </p>
            <p className="mt-4 flex flex-wrap items-center gap-3 text-xs text-[#efe6d8]/50">
              <span className="flex items-center gap-1">
                <i className="ri-shield-check-line"></i>
                信源可查
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-verified-badge-line"></i>
                多方立场完整呈现
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-refresh-line"></i>
                实时更新
              </span>
            </p>
          </div>

          {navCols.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-bold text-white">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="text-sm text-[#efe6d8]/70 transition-colors hover:text-red-400"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 border-t border-[#efe6d8]/10 pt-6">
          <div className="flex flex-col gap-3 text-sm text-[#efe6d8]/60 sm:flex-row sm:items-center sm:justify-between">
            <p>© 2026 全网热瓜 · 全网热门事件追踪信息站</p>
            <div className="flex flex-wrap items-center gap-4 text-xs text-[#efe6d8]/40">
              <a href="#faq" className="hover:text-red-400">
                内容免责声明
              </a>
              <a href="#subscribe" className="hover:text-red-400">
                订阅推送
              </a>
              <a href="mailto:hello@quanwang-remen.example" className="hover:text-red-400">
                联系编辑部
              </a>
            </div>
          </div>
          <p className="mt-3 text-xs leading-relaxed text-[#efe6d8]/35">
            本站内容均基于公开信源整理，用于信息聚合与参考，不构成对任何个人或组织的定性结论。内容不代表本站立场，请读者理性看待、自行判断。
          </p>
        </div>
      </div>
    </footer>
  );
}